import React, { useEffect } from 'react';
import { Hidden } from '@material-ui/core';
import Loader from '@cpg-its/ads.common.loading-circle';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useRouteMatch } from 'react-router';
import { setCurrentDioceseInstitution, setDioceseInstitutionClientNumber, setDioceseInstitutionGuid, setDioceseInstitutionList } from '../institutions/institution-slice';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { DioceseInstitutionItem, InstitutionState } from '../institutions/institution-model';
import { SearchProps } from '../../models/arc-epi-props';
import { SearchBar } from '../../../../search/components/search-bar';
import { ListPagination } from '../../../../search/components/list-pagination';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { TcsmStates } from '../../../../root/tcsm-model';
import { sortTableStyles } from '../../../../global/constants/theme/styles/tables/generic-sort-table';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { setNavigationContext } from '../../../../global/ducks/app-context';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { DioceseInstitutionListLabels } from './diocese-institution-list-labels';
import { DioceseInstitutionItemView } from './diocese-institution-item-view';
import { getDioceseOrganizations } from '../../../../global/ducks/organization-prc-api';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { ArcRoutes } from '../../constants/routes';

function DioceseInstitutionSearch() {

	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const initialList = useSelector<TcsmStates, DioceseInstitutionItem[]>(state => state.institutionState.dioceseInstitutionList);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps.searchSettingsState.epiContent);
	const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);
	const routeMatch = useRouteMatch();

	const { state } = useLocation<any>();

    const history = useHistory();
    const dispatch = useDispatch();
    const tableClasses = sortTableStyles();
    const gpsItem = useGpsType(GpsType.INSTITUTION_LIST);    

	const dioceseSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.DioceseRoot}`);

	const onSet = (item: DioceseInstitutionItem) => {
		dispatch(setDioceseInstitutionClientNumber(item.client_number));
		dispatch(setDioceseInstitutionGuid(item.guid));
		dispatch(setNavigationContext(NavigationContext.DioceseInstitution));		
		dispatch(setCurrentDioceseInstitution(item));		
		
		if (state?.actionLink && state?.actionLink !== routeMatch) history.push(state.actionLink, state);					
	};

	const dioceseClientNumber = institutionState?.institutionClientNumber;

	useEffect(() => {
		if (dioceseClientNumber){
			dispatch(getDioceseOrganizations(dioceseClientNumber, (data) => dispatch(setDioceseInstitutionList(data?.data?.institutions?.organizations))));
		}
	}, [dioceseClientNumber]);

	useEffect(() => {
		if (userNavigationContext === NavigationContext.DioceseInstitution){
			dispatch(setNavigationContext(NavigationContext.None));
		}		
	}, [userNavigationContext]);

	useEffect(() => {
		if (initialList?.length === 1) {
			const item = initialList[0];
			onSet(item);
		}
	}, [initialList?.length]);

	if (!dioceseClientNumber) {
		return (
			<Redirect to=
				{
					{
						pathname: dioceseSelect,
						state: {
							actionLink: routeMatch.path,
						},
					}
				}
			/>);
	}

	if (!institutionState.dioceseInstitutionListLoaded) {
		return (<Loader />);
	}	

	return (
		<>
			<PageHeader
				headerText={searchSettings?.institutionSearchPageTitle}
            />
            <Hidden mdUp>
                <SideBarContent>
                    <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                </SideBarContent>
            </Hidden>
			<SearchApp initialList={initialList} appName='DioceseInstitutionSearch'>
				{
					initialList?.length >= 10 && <SearchBar label={searchSettings.searchBarLabel} name='institution-search-bar' filterProps={['client_number', 'organization_name', 'city']} />
				}
				<div className={tableClasses.sortTable}>
					<Hidden xsDown>
						<DioceseInstitutionListLabels settings={searchSettings} />
					</Hidden>
					<div className='sort-table-content'>
						<SearchList
							renderList={
								(item: DioceseInstitutionItem) => {
									if (!item?.client_number) return null;
									return <DioceseInstitutionItemView settings={searchSettings} key={item.client_number} item={item} action={() => { onSet(item); }} />;
								}
							}
							renderPagination={
								(totalCounts, name) => {
									return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings.nextButton} prevButton={searchSettings.previousButton} />;
								}
							}
							emptyMessage={searchSettings.emptyListMessage}
						/>
					</div>
				</div>
			</SearchApp>
		</>
	);
}

export default DioceseInstitutionSearch;